import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import LinkPreview from './components/LinkPreview';
app.initializers.add('datlechin/flarum-link-preview', () => {
  extend(CommentPost.prototype, 'refreshContent', function () {
    var _app$forum$attribute, _app$forum$attribute2, _app$forum$attribute3;
    const convertMediaUrls = (_app$forum$attribute = app.forum.attribute('datlechin-link-preview.convertMediaURLs')) != null ? _app$forum$attribute : false;
    const useGoogleFavicons = (_app$forum$attribute2 = app.forum.attribute('datlechin-link-preview.useGoogleFavicons')) != null ? _app$forum$attribute2 : false;
    const openLinksInNewTab = (_app$forum$attribute3 = app.forum.attribute('datlechin-link-preview.openLinksInNewTab')) != null ? _app$forum$attribute3 : false;
    const linkSelectorExcludes = ['.PostMention', '.UserMention', '.LinkPreview-link', '.LinkPreview-captured'].map(cls => ":not(".concat(cls, ")")).join('');
    this.element.querySelectorAll(".Post-body a[rel]".concat(linkSelectorExcludes)).forEach(link => {
      var _link$textContent$rep, _link$textContent;
      if (link.classList.contains('LinkPreview-captured')) {
        return;
      }
      if (link.href.replace(/\/$/, '') !== ((_link$textContent$rep = (_link$textContent = link.textContent) == null ? void 0 : _link$textContent.replace(/\/$/, '')) != null ? _link$textContent$rep : '')) {
        return;
      }
      if (convertMediaUrls) {
        const normalizedUrl = link.href.replace(/^https?:\/\/(.+?)\/?$/i, '$1');
        if (normalizedUrl.match(/\.(jpe?g|png|gif|svg|webp|mp3|mp4|m4a|wav)$/)) {
          return;
        }
      }
      const wrapper = document.createElement('div');
      link.parentNode.insertBefore(wrapper, link);
      link.style.display = 'none';
      link.classList.add('LinkPreview-captured');
      m.mount(wrapper, {
        view: () => m(LinkPreview, {
          link,
          useGoogleFavicons,
          openLinksInNewTab
        })
      });
    });
  });
});